import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Button from "@material-ui/core/Button";
import colors from "../constants/colors";

const ConfirmationModal = ({ isOpen, toggle, hasError, claimId }) => (
  <Modal isOpen={isOpen} toggle={toggle}>
    {hasError ? (
      <ModalHeader style={{ color: "red" }}>Error</ModalHeader>
    ) : (
      <ModalHeader style={{ color: colors.primary }}>
        Claim# {claimId}
      </ModalHeader>
    )}
    {hasError ? (
      <ModalBody>
        We were unable to submit your request. Please try again later.
      </ModalBody>
    ) : (
      <ModalBody>
        Claim Form Received! 👏
        <p />
        Your claim number is: {claimId}. Please save this for your reference.
        <p />
        Thank you for using Traista Lost & Found. We understand that losing an
        item can be stressful. Your claim is now running against the current
        database for a match. Typical match time is 3-5 business days, as
        updates come in daily from partner airports.
        <p />
        You will receive a confirmation shortly at the email address you
        provided. Please check your SPAM folder for emails from Traista, just in
        case it ends up there.
      </ModalBody>
    )}
    <ModalFooter>
      <Button
        style={{
          backgroundColor: colors.primary,
          color: "white",
          outlineColor: colors.primary,
          borderColor: colors.primary,
        }}
        onClick={toggle}
      >
        OK
      </Button>
    </ModalFooter>
  </Modal>
);

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/ConfirmationModal.js